var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"text-datos",staticStyle:{"color":"#6F737D"},attrs:{"name":"txtAlbaran","maxlength":"40","id":"txtAlbaran","tabindex":"8","type":"file"},on:{"change":_vm.previsualizar}})}
var staticRenderFns = []

export { render, staticRenderFns }